import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

export function useShortsAccess(user) {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    getDoc(doc(db, 'featureFlags', 'shorts'))
      .then((snap) => {
        const uids = snap.exists() ? (snap.data().allowedUids ?? []) : [];
        setHasAccess(uids.includes(user.uid));
      })
      .catch(() => setHasAccess(false))
      .finally(() => setLoading(false));
  }, [user]);

  return { hasAccess, loading };
}
